import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chart_type_line",
  "use": "chart_type_line-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chart_type_line\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.46667 4.00854H4.5V15.8034V16.7863H5.46667H16.1V15.8034H5.46667V4.00854Z\" fill=\"black\" />\n<path d=\"M7.3999 12.9468L10.1051 8.923L11.6911 10.3974L14.1666 7.03174\" stroke=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol